module.exports = __webpack_public_path__ + "static/img/map_jiangsu.96de9ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join/map_jiangsu.png
// module id = g/IY
// module chunks = 0